import React from 'react';
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import { useColumnPanelActions } from '../TableColumnServices/useColumnPanelActions';

export const ColumnPanelFooter = ({ defaultTableState }) => {
  const apiRef = useGridApiContext();
  const {
    isToggleAllChecked,
    isToggleAllIndeterminate,
    isResetDisabled,
    toggleAllColumns,
    resetToDefault
  } = useColumnPanelActions(apiRef, defaultTableState?.columns?.columnVisibilityModel);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        px: 3,
        py: 0.5
      }}
    >
      <FormControlLabel
        control={<Checkbox checked={isToggleAllChecked} indeterminate={isToggleAllIndeterminate} sx={{ p: 0.5 }} />}
        label="Show/Hide All"
        sx={{ m: 0 }}
        onChange={() => toggleAllColumns()}
      />
      <Button
        disabled={isResetDisabled}
        onClick={() => resetToDefault(defaultTableState?.columns?.columnVisibilityModel)}
      >
        Reset
      </Button>
    </Box>
  );
};
